import React from 'react';
import { CheckIcon, CreditCardIcon, DownloadIcon, InfinityIcon, ShieldCheckIcon } from 'lucide-react';
import { BONUS_VALUE, CORE_PRICE, DISCOUNT_PERCENT, HERO_IMAGE, SALE_PRICE, TOTAL_VALUE, offerIncludes } from '../data/content';
import { OFFER_SIZES, OFFER_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/images';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
const trustBadges = [{
  icon: CreditCardIcon,
  label: 'One-time payment'
}, {
  icon: InfinityIcon,
  label: 'Lifetime access'
}, {
  icon: DownloadIcon,
  label: 'Instant download'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function OfferSection() {
  return <section id="offer" className="w-full scroll-mt-4 border-y border-white/5 bg-steel-900 px-6 py-16 sm:py-20" aria-labelledby="offer-title" data-id="element-120" data-mp="wawubqqbprv6">
      <div className="mx-auto max-w-6xl" data-id="element-121" data-mp="2y3ktnozujv5o">
        <SectionHeading id="offer-title" title={<>
              Total value ${TOTAL_VALUE}. <Accent data-id="element-123" data-mp="12p36z8q07qqa">Yours today for ${SALE_PRICE}.</Accent>
            </>} subtitle="Educators often pay for their own materials. That is exactly why the IIIS 2026 is priced to be accessible." data-id="element-122" data-mp="2y4mdahuxhpz0" />

        <div className="mt-10 grid items-center gap-8 lg:grid-cols-[1fr_1fr] lg:gap-12" data-id="element-124" data-mp="syi7zk6f4k6u">
          <Reveal className="relative mx-auto w-full max-w-md" data-id="element-125" data-mp="ox57lpm3h97b">
            <img src={optimizedImage(HERO_IMAGE, 560)} srcSet={optimizedSrcSet(HERO_IMAGE, OFFER_WIDTHS)} sizes={OFFER_SIZES} alt="Everything included: six core volumes, six bonus guides and printable classroom worksheets" width={1000} height={1000} loading="lazy" decoding="async" className="h-auto w-full drop-shadow-[0_24px_48px_rgba(0,0,0,0.8)]" data-id="element-126" data-mp="1lm4ccungzsur" />
            <span className="absolute -right-1 top-1 flex h-20 w-20 flex-col items-center justify-center bg-ember-500 font-display font-bold leading-none text-steel-950 sm:h-24 sm:w-24" data-id="element-127" data-mp="17m3g5si5h9lm">
              <span className="text-2xl sm:text-3xl" data-id="element-128" data-mp="3sc16bszbvsne">{DISCOUNT_PERCENT}%</span>
              <span className="mt-1 text-[0.6rem] uppercase tracking-[0.18em]" data-id="element-129" data-mp="3ttq1cj56a3hg">Off</span>
            </span>
          </Reveal>

          <Reveal index={1} data-id="element-130" data-mp="2n6hyfl9t57j">
            <div className="border border-white/[0.09] bg-steel-850 px-6 py-8 text-center sm:px-9" data-id="element-131" data-mp="2lc57ok5kjej">
              

              <p className="mt-6 font-display text-xs font-semibold uppercase tracking-[0.2em] text-ember-400" data-id="element-132" data-mp="3oumtys1pzl6b">
                Special launch price
              </p>
              <p className="mt-1 font-display text-6xl font-bold text-ink-50 sm:text-7xl" data-id="element-133" data-mp="3b1f2r1hjwrp5">
                ${SALE_PRICE}
              </p>
              <p className="mt-2 text-xs uppercase tracking-[0.14em] text-ink-500" data-id="element-134" data-mp="315u7dm6zmpod">
                One-time payment · Digital download
              </p>

              <CtaButton className="mt-7" fullWidth href={CHECKOUT_URL} label="Get The Full System Now" data-id="element-135" data-mp="364on2f9nry49" />

              <ul className="mx-auto mt-6 grid max-w-sm grid-cols-2 gap-y-2 text-xs text-ink-400" data-id="element-136" data-mp="2s6qlybkcly6p">
                {trustBadges.map(({
                icon: Icon,
                label
              }) => <li key={label} className="flex items-center justify-center gap-1.5" data-id="element-137" data-mp="2di72axmnfwxa">
                    <Icon className="h-3.5 w-3.5 text-circuit-400" aria-hidden="true" data-id="element-138" data-mp="28kf0nbw7cwfw" />
                    {label}
                  </li>)}
              </ul>

              <ul className="mt-7 grid gap-2 border-t border-white/[0.08] pt-6 text-left" data-id="element-139" data-mp="2igibd654e3eg">
                {offerIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink-200" data-id="element-140" data-mp="2wfri7f7frl5r">
                    <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-ember-400" strokeWidth={3} aria-hidden="true" data-id="element-141" data-mp="2rihuc3zp3hk1" />
                    <span data-id="element-142" data-mp="3662x1wsnrerf">{item}</span>
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}